import { Outlet } from "react-router-dom";

const Reportes = () => {
  return (
    <div style={{ marginTop: "10px" }}>
      <Outlet />
    </div>
  );
};

export default Reportes;
